import { PageStructure } from '@app-velocity/common/types';

import { createCoreMethod } from '../../utils/createCoreMethod';
import { shallowFindInContainer } from '../../utils/shallowFind';
import { getStructure } from '../structure/getStructure';
import { findNodeById } from '../../utils/findNodeById';
import { isNodeWithSize } from '../../utils/isNodeWithSize';

export const getPageStructure = createCoreMethod(
  'getPageStructure',
  async (
    nodeId: string,
    parentNodeId?: string
  ): Promise<PageStructure | null> => {
    await figma.currentPage.loadAsync();

    let parentNode: BaseNode | null = figma.currentPage;

    if (parentNodeId) {
      parentNode = shallowFindInContainer(parentNodeId, figma.currentPage);

      if (!parentNode) {
        parentNode = findNodeById(parentNodeId, figma.currentPage, 99);
      }
    }

    if (!parentNode) return null;

    let node: BaseNode | null = shallowFindInContainer(nodeId, parentNode);

    if (!node) {
      node = findNodeById(nodeId, figma.currentPage, 99);
    }

    if (!node || !isNodeWithSize(node)) return null;

    const structure = await getStructure(node);

    return { width: node.width, structure };
  }
);
